/**
 * EntryProofBundlePage.jsx
 * Route: /entry-proof-bundle
 *
 * Every entry form for one event on one page, one form per printed page,
 * with an index first. Only the backend's PDF renderer uses it
 * (pdf_utils.render_entry_forms_pdf, for the secretary's backup zip): the
 * renderer puts the event and submissions in window.__PDF_DATA__ before the
 * page loads, so there is nothing to fetch and no login. Opened in a normal
 * browser it just says there is nothing to show.
 */
import '../Secretary.css';
import '../EntryForm.css';
import EntrySubmissionView from './EntrySubmissionView';

const fmtDate = (iso) => (iso
  ? new Date(`${iso}T00:00:00`).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })
  : '');

const riderName = (s) => {
  const r = s.payload?.rider || {};
  return `${r.firstName || ''} ${r.surname || ''}`.trim() || '(no name)';
};

export default function EntryProofBundlePage() {
  const data = window.__PDF_DATA__;
  const submissions = data?.submissions || [];

  return (
    <div className="secretary-portal App entry-form-page entry-proof-bundle" data-proof-ready="true"
         style={{ maxWidth: 900, margin: '0 auto', padding: '1.5rem' }}>
      {/* Shadows become pictures in a PDF: without them a 100-entry PDF is
          much smaller and quicker to make. */}
      <style>{'.entry-proof-bundle * { box-shadow: none !important; }'}</style>
      {!data && <p>Nothing to show.</p>}
      {data && (
        <div className="sec-section">
          <h2 style={{ marginTop: 0 }}>Entry forms: {data.event.eventname || data.event.hill}</h2>
          <p style={{ color: 'var(--text-light)' }}>
            {fmtDate(data.event.date)} · {submissions.length} online {submissions.length === 1 ? 'entry' : 'entries'}, in surname order.
            Entries the secretary added by hand have no online form.
          </p>
          <table className="entries-table" style={{ width: '100%' }}>
            <thead>
              <tr><th>#</th><th>Rider</th><th>Race no.</th><th>Status</th><th>Entry ref</th></tr>
            </thead>
            <tbody>
              {submissions.map((s, i) => (
                <tr key={s.id}>
                  <td>{i + 1}</td>
                  <td>{riderName(s)}</td>
                  <td>{(s.race_numbers || []).join(', ') || '—'}</td>
                  <td>{s.status}</td>
                  <td>{s.id}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {submissions.map(s => (
        <div key={s.id} style={{ breakBefore: 'page' }}>
          <h1 style={{ fontSize: '1.1rem', margin: '0 0 0.5rem' }}>
            {riderName(s)}{s.race_numbers?.length ? ` (No. ${s.race_numbers.join(', ')})` : ''}
          </h1>
          <EntrySubmissionView event={data.event} submission={s} />
        </div>
      ))}
    </div>
  );
}
